module.exports = __webpack_public_path__ + "static/img/6_2.4aa7d9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/6_2.png
// module id = vdbn
// module chunks = 0